


<div>
  <tabset #staticTabs>
    <tab heading="Downtown LA" #tabA="tab">

        <div class="container-fluid">
          <div class="row">
            <div class="col-md-5 contact-info">
              <h3 class="title">
                {{ 'OfficeLocations.pageTitle' | translate}}
              </h3>
              <p><strong>Kenneth Hahn Hall of Administration</strong></p>
              <p>500 W. Temple Street, Room 225</p>
              <p>Los Angeles, CA 90012-2770</p>
              <br>
              <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
              <p>(213) 974-3211</p>
              <p>(888) 807-2111 toll-free</p>
              <p>Si necesita asistencia en Español, por favor llame gratis al (888) 807-2111 y oprima "2" al escuchar el mensaje.</p>
              <br>
              <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
              <p>Monday - Friday 8:00am - 5:00pm </p>
              <p><i>Must be in line by 4:45pm</i></p>
            </div>
            <div class="col-md-7">
              <app-map-slice [latitude]="markers[0].lat" [longitude]="markers[0].lng" [markerTitle]="'Hall of Administration'"></app-map-slice>
            </div>
          </div>

        </div>



    </tab>
    <tab heading="Sylmar (Closed)" #tabB="tab">

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.NorthPageTitle' | translate}}
            </h3>
            <p style="color: #AC2029;"><strong>{{ 'OfficeLocations.Temporary' | translate}}</strong></p>
            <p><strong>Kenneth Hanh Hall of Administration, Room 225.</strong></p>
            <p><i>Room 293 (Mailing Address)</i></p>
            <p>500 W. Temple Street</p>
            <p>Los Angeles, CA 90012-2770</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(818) 833-6000</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>
            <p><i>Must be in line by 4:45pm</i></p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[1].lat" [longitude]="markers[1].lng" [markerTitle]="'North District'"></app-map-slice>
          </div>
        </div>

      </div>

    </tab>

    <tab heading="Castaic Library" #tabB="tab">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'Castaic Library Satellite Site' | translate}}
            </h3>
            <p>{{ 'OfficeLocations.Castaic' | translate}}</p><br>
            <p><strong>Castaic Library</strong></p>

            <p>27971 Sloan Canyon Road</p>
            <p>Castaic, CA 91384</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(818) 833-6000</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday & Friday only 10:00am - 5:00pm</p>
            <p><i>Must be in line by 4:45pm</i></p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[7].lat" [longitude]="markers[7].lng" [markerTitle]="'Castaic Library'"></app-map-slice>
          </div>
        </div>

      </div>
    </tab>

    <tab heading="South El Monte" #tabC="tab">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.EastPageTitle' | translate}}
            </h3>
            <p>1190 Durfee Avenue</p>
            <p>South El Monte, CA 91733</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(626) 258-6001</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[2].lat" [longitude]="markers[2].lng" [markerTitle]="'East District'"></app-map-slice>
          </div>
        </div>

      </div>
    </tab>
    <tab heading="Signal Hill" #tabD="tab">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.SouthPageTitle' | translate}}
            </h3>
            <p>1401 E. Willow Street</p>
            <p>Signal Hill, CA 90755</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(562) 256-1701</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[3].lat" [longitude]="markers[3].lng" [markerTitle]="'South District Office'"></app-map-slice>
          </div>
        </div>

      </div>
    </tab>
    <tab heading="Culver City" #tabE="tab">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.WestPageTitle' | translate}}
            </h3>
            <!-- <p style="color:red"><strong>Public services are temporarily moved to: </strong></p>
            <p><strong>Kenneth Hahn Hall of Administration, Room 225.</strong></p><p><i>Room 183-19 (mailing address)</i></p> -->
            <p>6167 Bristol Parkway, Suite 100</p>
            <p>Culver City, CA 90230</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(310) 665-5300</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>
            <!-- <p><i>Must be in line by 4:45pm</i></p> -->

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[4].lat" [longitude]="markers[4].lng" [markerTitle]="'West Regional Office'"></app-map-slice>
          </div>
        </div>

      </div>
    </tab>

    <tab heading="Beverly Hills " #tabF="tab">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'Beverly Hills Courthouse Office' | translate}}
            </h3>
            <p>9355 Burton Way, Suite 400</p>
            <p>Beverly Hills, CA 90210</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(310) 665-5300</p>
            <br>
            <p><strong>{{ 'Office Hours' | translate}}</strong></p>
            <p><i>(except County and Superior Court holidays)</i><br>
              Tuesday - Thursday 8:00am - 4:00pm<br>
              <i>Must be in line by 3:45pm</i></p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[6].lat" [longitude]="markers[6].lng" [markerTitle]="'Beverly Hills Courthouse'"></app-map-slice>
          </div>
        </div>

      </div>
    </tab>

    <tab heading="Lancaster Regional" #tabG="tab">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5 contact-info">
            <h3 class="title">
              {{ 'OfficeLocations.LancasterPageTitle' | translate}}
            </h3>
            <p>251 E. Avenue K6</p>
            <p>Lancaster, CA 93535</p>
            <br>
            <p><strong>{{ 'OfficeLocations.Phone' | translate}}</strong></p>
            <p>(661) 940-6700</p>
            <br>
            <p><strong>{{ 'OfficeLocations.OfficeHours' | translate}}</strong></p>
            <p>Monday - Friday 8:00am - 5:00pm </p>

          </div>
          <div class="col-md-7">
            <app-map-slice [latitude]="markers[5].lat" [longitude]="markers[5].lng" [markerTitle]="'Lancaster Regional Office'"></app-map-slice>
          </div>
        </div>

      </div>
    </tab>
  </tabset>
</div>





